export enum TableTabId {
  selector = "selector",
  create = "create",
}